import { OrganizationKeyName } from "../../../model/Organization";

export const UPSERT_PRODUCT_CATEGORY_SUCCESS =
  "SHOP:UPSERT_PRODUCT_CATEGORY_SUCCESS";

export const upsertProductCategorySuccessAction = (
  organization: OrganizationKeyName,
  id?: string
) => ({
  type: UPSERT_PRODUCT_CATEGORY_SUCCESS as typeof UPSERT_PRODUCT_CATEGORY_SUCCESS,
  organization,
  id,
});

export type UpsertProductCategorySuccessAction = ReturnType<
  typeof upsertProductCategorySuccessAction
>;
